.bw{justify-content:flex-end;}